"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  onDoubleClick: true, // ondblclick

  onAnimationStart: true,
  onAnimationEnd: true,
  onAnimationIteration: true,
  onTransitionEnd: true,

  onCompositionEnd: true,
  onCompositionStart: true,
  onCompositionUpdate: true,

  onDragExit: true,

  onTouchCancel: true,
  onTouchEnd: true,
  onTouchMove: true,
  onTouchStart: true
};